import { createNode, createOptional } from '@glueapp/graph-types';

export const DefaultForOptional = createNode({
    id: 'Default for Optional',
    name: 'Default for Optional',
    description: 'Returns the value if present, otherwise returns the default value',
    aiDescription: [
        'Unwraps an optional value with a fallback. If "Optional Value" is present, outputs it;',
        'otherwise outputs the "Default" value. Both ports share generic type T.',
        'Input: "Optional Value" (optional<T>), "Default" (T). Output: "Output" (T).',
    ].join('\n'),
    category: 'Object',
    color: '#a17ee2',
    integration: undefined,
    inPorts: {
        'Optional Value': createOptional({ kind: 'generic', identifier: 'T' }),
        Default: { kind: 'generic', identifier: 'T' },
    },
    outPorts: {
        Output: { kind: 'generic', identifier: 'T' },
    },
    execute: function (input) {
        return {
            output: {
                Output: input.inPorts['Optional Value'] ?? input.inPorts.Default,
            },
        };
    },
});
